import { CARD_HEIGHT, ROW_HEIGHT, getMatchY } from '../../bracketLayout';

export const PADDING_X = 33;
export const PADDING_Y = 32;
export const STUB_LENGTH = 40;

// Posición Y del card en la ronda Final
export const getFinalY = (ei, mi) => {
  // Calculate the pitch between semifinals
  const factor = Math.pow(2, ei - 1);
  const pitch = factor * ROW_HEIGHT;
  
  // Center Final and 3° lugar between the two semifinals
  // baseY is shifted up so that the pair is centered
  const baseY = getMatchY(ei, 0) - pitch / 2;
  
  if (mi === 0) return baseY;
  return baseY + pitch;
};

// Posición Y de un card según ronda y match
export const cardY = (ei, mi, isFinal) =>
  isFinal ? getFinalY(ei, mi) : getMatchY(ei, mi);

// Altura máxima del board según las entradas visibles
export const maxHeight = entries => {
  let h = 0;
  entries.forEach(({ effectiveIdx: ei, round: r }) => {
    const last = r.matches.length - 1;
    const bottom = cardY(ei, last, r.id === 'final') + CARD_HEIGHT;
    if (bottom > h) h = bottom;
  });
  return h;
};
